import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import axios from 'axios';
import { toast } from 'sonner';
import { Lock } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AdminLoginPage = () => {
  const navigate = useNavigate();
  const [credentials, setCredentials] = useState({ username: '', password: '' });
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await axios.post(`${API}/admin/login`, credentials);
      localStorage.setItem('adminToken', response.data.access_token);
      toast.success('Login successful!');
      navigate('/admin/dashboard');
    } catch (error) {
      console.error('Login error:', error);
      toast.error('Invalid credentials');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="min-h-screen flex items-center justify-center px-6">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="w-full max-w-md"
      >
        <div className="text-center mb-12">
          <div className="inline-flex items-center justify-center mb-4">
            <img 
              src="https://customer-assets.emergentagent.com/job_c2d28a08-ae0d-49cc-b72b-7be69e3b538c/artifacts/daj5mwbp_IMG_3269.png"
              alt="Vision Tattoo Logo"
              className="h-20 w-20 object-contain rounded-full"
              style={{ mixBlendMode: 'multiply' }}
            />
          </div>
          <h1 className="font-heading text-4xl md:text-5xl font-medium tracking-tight mb-2">
            Admin Login
          </h1>
          <p className="font-mono text-xs uppercase tracking-widest text-muted-foreground mb-1">
            Vision Tattoo
          </p>
          <p className="font-mono text-xs uppercase tracking-[0.3em] text-muted-foreground/70">
            Trust The Process
          </p>
        </div>

        <form onSubmit={handleLogin} data-testid="admin-login-form" className="space-y-6">
          <div>
            <label className="font-mono text-xs uppercase tracking-widest mb-4 block">
              Username
            </label>
            <input
              type="text"
              data-testid="username-input"
              value={credentials.username}
              onChange={(e) => setCredentials({ ...credentials, username: e.target.value })}
              className="w-full bg-transparent border-b border-primary/20 focus:border-primary rounded-none px-0 py-4 placeholder:text-muted-foreground/50 focus:ring-0 transition-colors"
              required
            />
          </div>

          <div>
            <label className="font-mono text-xs uppercase tracking-widest mb-4 block">
              Password
            </label>
            <input
              type="password"
              data-testid="password-input"
              value={credentials.password}
              onChange={(e) => setCredentials({ ...credentials, password: e.target.value })}
              className="w-full bg-transparent border-b border-primary/20 focus:border-primary rounded-none px-0 py-4 placeholder:text-muted-foreground/50 focus:ring-0 transition-colors"
              required
            />
          </div>

          <button
            type="submit"
            data-testid="login-button"
            disabled={loading}
            className="w-full bg-primary text-primary-foreground px-8 py-4 rounded-none hover:bg-primary/90 transition-all duration-300 uppercase tracking-widest text-xs font-mono disabled:opacity-50"
          >
            {loading ? 'Logging in...' : 'Login'}
          </button>
        </form>

        <p className="text-center font-body text-sm text-muted-foreground mt-8">
          For demo purposes, create admin via API: POST /api/admin/setup
        </p>
      </motion.div>
    </div>
  );
};

export default AdminLoginPage;